export const fontSizes = [
  8,   // 0
  12,  // 1
  14,  // 2
  16,  // 3
  20,  // 4
  24,  // 5
  32,  // 6
  48,  // 7
  64,  // 8
  96,  // 9
];
